import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import GatsbyImage from "../common/gatsby-image"
import { Link } from "gatsby"
import { getTranslation, getLanguage } from "../../utils"

const StyledProduct = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 35rem;
  padding: 0 1rem;
  margin-bottom: 7rem;

  @media (min-width: 769px) {
    padding: 0 3rem;

    .gatsby-image-wrapper {
      height: 24rem;
    }
  }

  .gatsby-image-wrapper {
    transition: 200ms linear;

    img {
      object-fit: contain !important;
    }
  }
`

const StyledLink = styled(props => <Link {...props} />)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;

  &:hover {
    .gatsby-image-wrapper {
      opacity: 0.75;
    }

    h3 {
      color: ${props => props.theme.crockpot.main};
    }
  }
`

const StyledProductTitle = styled.h3`
  max-width: 32rem;
  color: ${props => props.theme.crockpot.text};
  text-transform: uppercase;
  font-family: ${props => props.theme.crockpot.secondFont};
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 1.3rem;
  text-align: center;
  margin: 1rem auto 0;
  transition: 100ms linear;

  @media (min-width: 769px) {
    font-size: 1.9rem;
    line-height: 2.3rem;
    margin: 2.5rem auto 0;
  }
`

const ProductRating = styled.div`
  padding-top: 1rem;
`

const SingleProduct = ({
  product = null,
  isSmallVersion = false,
  showRatings = false,
}) => {
  if (!product) return null

  const productsLink = `${getLanguage()}/${getTranslation("products")}`

  return (
    <StyledProduct data-testid="single-product" isSmallVersion={isSmallVersion}>
      <StyledLink
        to={`${productsLink}/${product.slug}`}
        aria-label={product.productTitle}
      >
        {product.productImages && (
          <GatsbyImage image={product.productImages[0].gatsbyImageData} />
        )}
        <StyledProductTitle isSmallVersion={isSmallVersion}>
          {product.productTitle}
        </StyledProductTitle>
        {showRatings && product.bvProductId && (
          <ProductRating
            data-bv-show="inline_rating"
            data-bv-product-id={product.bvProductId}
          />
        )}
      </StyledLink>
    </StyledProduct>
  )
}

SingleProduct.propTypes = {
  product: PropTypes.object,
  isProductsPage: PropTypes.bool,
  showRatings: PropTypes.bool,
}

export default SingleProduct
